import { ButtonGroup } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Stack, styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 24px",
  borderBottom: "1px solid rgba(152, 162, 179, 0.15)",
}));

export const GridDetails = styled("div")(() => ({
  rowGap: "22px",
  display: "grid",
  gridTemplateColumns: "auto auto auto auto auto",
  padding: "24px",
}));

export const InventoryContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 24px",
  backgroundColor: colors.gray100,
}));

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "22px",
  fontWeight: 600,
  lineHeight: "28px",
  color: colors.gray600,
}));

export const TitleDetails = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  color: colors.gray600,
}));

export const InfoDetails = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  color: colors.gray500,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const TextMarkItems = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  color: colors.gray600,
}));

export const Line = styled("div")(() => ({
  height: "1px",
  backgroundColor: colors.gray200,
  marginRight: "15px",
}));

export const ButtonGroupStyled = styled(ButtonGroup)(() => ({
  width: "450px",
}));

export const ContainerGrid = styled("div")(() => ({
  padding: "24px",
  marginBottom: "72px",
}));

export const ContainerButtons = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  padding: "16px 24px",
  backgroundColor: colors.white,
  marginRight: "15px",
}));

export const StackLineButton = styled(Stack)(() => ({
  position: "absolute",
  bottom: "15px",
  width: "100%",
}));

export const useStyles = makeStyles(() => ({
  buttonGroup: {
    border: "none !important",
  },
}));
